import { Reducer } from 'redux';
import { defaultTelemetryApiName, defaultTelemetryType } from 'src/utils/constants';
import { ActionType, createStandardAction, getType } from 'typesafe-actions';

export type InitializeArgs = { selectedAPIName: string; selectedTelemetry: string };

export const apiTelemetrySelectorActions = {
  updateSelectedApiName: createStandardAction('@apiSelector/updateSelectedApiName')<{
    selectedApiName: string;
  }>(),

  updateSelectedTelemetryType: createStandardAction('@apiSelector/updateSelectedTelemetryType')<{
    selectedTelemetry: string;
  }>(),
};

export type ApiTelemetrySelectorActions = ActionType<typeof apiTelemetrySelectorActions>;

export type ApiTelemetrySelectorState = {
  readonly selectedApiName: string;
  readonly selectedTelemetry: string;
};

export type RootState = { apiTelemetrySelector: ApiTelemetrySelectorState };

export const apiTelemetrySelectorInitialState: ApiTelemetrySelectorState = {
  selectedApiName: defaultTelemetryApiName,
  selectedTelemetry: defaultTelemetryType,
};

export const apiTelemetrySelector: Reducer<ApiTelemetrySelectorState, ApiTelemetrySelectorActions> = (
  state = apiTelemetrySelectorInitialState,
  action,
) => {
  switch (action.type) {
    case getType(apiTelemetrySelectorActions.updateSelectedApiName): {
      return { ...state, selectedApiName: action.payload.toString() };
    }
    case getType(apiTelemetrySelectorActions.updateSelectedTelemetryType): {
      return { ...state, selectedTelemetry: action.payload.toString() };
    }
    default: {
      return state;
    }
  }
};

export const apiTelemetrySelectors = {
  selectedAPIName: (state: RootState) => state.apiTelemetrySelector.selectedApiName,
  selectedTelemetryType: (state: RootState) => state.apiTelemetrySelector.selectedTelemetry,
};
